import { IconLogout2, IconUser, IconUserCircle } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { ActionIcon, Avatar, Group, Menu, Stack, Text } from '@mantine/core';
import { useAuth } from '@/contexts/AuthContext';
import { useMenuContext } from '@/hooks/organizerHooks/useMenuContext';


const initialsOf = (name: string | undefined) => {
  if (!name) {
    return '';
  }
  const [firstName, secondName] = name.split(' ');
  return `${firstName?.[0] || ''}${secondName?.[0] || ''}`.toUpperCase();
};

/** Botão do usuário no cabeçalho (ao lado do tema): nome, e-mail, papel, perfil e sair. */
export const UserMenu = ({ size = 38 }: { size?: number }) => {
  const { currentUser, logout } = useAuth();
  // Sem papel de organizador: quem tem evento próprio aparece como Organizador
  const { isAdmin, ownsEvents } = useMenuContext();
  const roleLabel = isAdmin ? 'Administrador' : ownsEvents ? 'Organizador' : 'Atleta';

  return (
    <Menu position="bottom-end" width={260} shadow="md" withinPortal>
      <Menu.Target>
        <ActionIcon aria-label="Usuário" size={size} color="grey" variant="outline" radius="md">
          <IconUser size="66%" color="grey" />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        <Group wrap="nowrap" p="xs" gap="sm">
          <Avatar size={44} radius="md">
            {initialsOf(currentUser?.name)}
          </Avatar>
          <Stack gap={0} style={{ minWidth: 0 }}>
            <Text size="sm" fw={600} truncate="end">
              {currentUser?.name}
            </Text>
            <Text size="xs" c="dimmed" truncate="end">
              {currentUser?.email}
            </Text>
            <Text size="xs" fw={500} c="principal.7">
              {roleLabel}
            </Text>
          </Stack>
        </Group>
        <Menu.Divider />
        <Menu.Item
          component={Link}
          to="/dashboard/meu-perfil"
          leftSection={<IconUserCircle size={16} />}
        >
          Meu perfil
        </Menu.Item>
        <Menu.Item
          component="a"
          href="/"
          onClick={logout}
          color="red"
          leftSection={<IconLogout2 size={16} />}
        >
          Sair
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
